export const SUPPORT_EMAIL = 'jobs@davidcareers.com';

export const PROFILE_LOADER_TEXTS = [
  'Organizing your expertise for maximum impact',
  'Fine-tuning every detail for a standout resume',
];

export const DEFAULT_LOADER_TEXTS = ['Gathering details', 'Loading data'];

export const STUB_DEFAULT_TEXTS = {
  mainText: 'No matching jobs found',
  subText: 'Please make sure your keywords are spelled correctly',
};

export const STUB_ERROR_TEXTS = {
  mainText: 'Jobs are taking longer than usual',
  subText: 'Please refresh the page in a minute',
};

export const HISTORY_STUB_TEXTS = {
  mainText: `You haven't opened any roles yet`,
  subText:
    'Once you open a role — from your matches email or anywhere on the site — it shows up here, so you can always find your way back to it.',
};

export const HISTORY_SEARCH_STUB_TEXTS = {
  mainText: 'No matching jobs found',
  subText: 'Try a different title, company, or location',
};
